import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import { EnvironmentUtils } from 'shared/util/environment-utils';

const useFeatureFlagAvailabilityUtil = (flagName: string): boolean => {
    const { flagsReady } = useFlagsStatus();
    const isFlagEnabled: boolean = useFlag(flagName);

    if (EnvironmentUtils.isDevelopmentEnvironment()) {
        return true;
    }

    return isFlagEnabled && flagsReady;
};

export default useFeatureFlagAvailabilityUtil;
